export const APPLICATION_ID_STORAGE_KEY = 'application-id';

export const HIDDEN_FIELD_VALUE = '********';
